import { GET_ALL_BANNERS, GET_ONE_BANNER } from '../types'

const initialState = {
    banners: null,
    banner: null,
}

export default function bannerReducer(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case GET_ALL_BANNERS:
            return {
                ...state,
                banners: payload,
                banner: null,
            }
        case GET_ONE_BANNER:
            return {
                ...state,
                banner: payload,
            }
        default:
            return state
    }
}
